import React from "react";
import currencyFormatter from "../../../helpers/currencyFormatter";

const FundsOnAccountBadge = ({ fundsOnAccount, className = "" }) => {
  if (!fundsOnAccount) return null;

  return (
    <div className={`tv-funds-on-account ${className}`.trim()}>
      <span className="tv-funds-on-account-label">Funds on Account:</span>
      <span className="tv-funds-on-account-values">
        Cash - {currencyFormatter.format(fundsOnAccount.cash?.net || 0)}
        {" | "}Credits - {currencyFormatter.format(fundsOnAccount.credits?.net || 0)}
        {" | "}Total: {currencyFormatter.format(fundsOnAccount.total?.net || 0)}
      </span>
    </div>
  );
};

export default FundsOnAccountBadge;
